import _ from "lodash";

function commentNode(el, vnode) {
  const comment = document.createComment(" ");

  Object.defineProperty(comment, "setAttribute", {
    value: () => undefined,
  });
  /*eslint-disable */
  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}

export default {
  install(Vue) {
    // eslint-disable-next-line complexity
    Vue.directive("can", (el, bindings, vnode) => {
      const behaviour = bindings.modifiers.disable ? "disable" : "hide";

      let abilities = {};
      if (_.isObject(bindings.value)) {
        abilities = bindings.value;
      } else {
        abilities[bindings.value] = bindings.arg;
      }

      const can = vnode.context.$root.$store.getters["core/hasAbility"];
      const ok = _.every(abilities, (value, key) => can(key, value));

      if (!ok) {
        switch (behaviour) {
          case "disable": {
            // eslint-disable-next-line no-param-reassign
            el.disabled = true;
            break;
          }
          default: {
            commentNode(el, vnode);
          }
        }
      }
    });

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$can = function (area, action) {
      return this.$store.getters["core/hasAbility"](area, action);
    };
  },
};
